<ng-template #templateContent>
    <ng-content></ng-content>
</ng-template>
<aurora-icon-button
        class="help_tooltip"
        variant="ghost"
        [attr.icon]="icon"
        [attr.aria-label]="title || icon"
        [ngClass]="{ 'on_dark' : color == 'white'}"
        [class.is-error]="icon === 'error'"
        [class.is-warning]="icon === 'warning'"
        [ngbPopover]="templateContent"
        [popoverTitle]="title"
        [triggers]="trigger"
        [placement]="placement"
        [autoClose]="'outside'"
        container="body"
        tabindex="0"
        [popoverClass]="'unity-tooltip bg-' + (bgColor || color)">
</aurora-icon-button>
